
export const languageOptionsMap: Record<string, { [key: string]: string }> = {
  IN: {
    Hindi: 'हिन्दी',
    Bengali: 'বাংলা',
    Telugu: 'తెలుగు',
    Marathi: 'मराठी',
    Tamil: 'தமிழ்',
    Gujarati: 'ગુજરાતી',
    Urdu: 'اردو',
    Punjabi: 'ਪੰਜਾਬੀ',
    Malayalam: 'മലയാളം',
    Odia: 'ଓଡ଼ିଆ',
    Kannada: 'ಕನ್ನಡ',
    Assamese: 'অসমীয়া',
  },
  AE: {
    Arabic: 'العربية'
  },
  SA: {
    Arabic: 'العربية'
  },
  BD: {
    Bengali: 'বাংলা'
  },
  TH: {
    Thai: 'ไทย'
  },
  GH: {
  },
  PH: {
    Filipino: 'Filipino'
  },
  CI: {
    French: 'Français'
  },
  NP: {
    Nepali: 'नेपाली'
  },
};
